import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../../styles/icons/logos/img.module.scss';

import srcBlack from '../../../../img/logo-urbania.png';
import srcWhite from '../../../../img/urbania-logo.png';

const propTypes = {
    color: PropTypes.oneOf(['black', 'white']),
    className: PropTypes.string,
};

const defaultProps = {
    color: 'black',
    className: null,
};

const UrbaniaCrackedIcon = ({ color, className }) => (
    <img
        src={color === 'black' ? srcBlack : srcWhite}
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
        alt="URBANIA"
    />
);

UrbaniaCrackedIcon.propTypes = propTypes;
UrbaniaCrackedIcon.defaultProps = defaultProps;

export default UrbaniaCrackedIcon;
